import { makeTranslationHelpers } from '@/hooks/useTranslation';

const { useTranslation: usePastTranslation, Translation: PastTranslation } =
  makeTranslationHelpers('page.companyReport.past');

export { usePastTranslation, PastTranslation };
